import React, { createContext, useContext } from 'react';
import {
  NEXUS_COMPETITORS,
  NEXUS_LINKEDIN_ADS_ITEMS,
  NEXUS_META_ADS_ITEMS,
  NEXUS_NEWS_ITEMS,
  NEXUS_READOUT,
  NEXUS_SEC_ITEMS,
  NEXUS_SERFF_ITEMS,
} from './nexusViewData';

export const NEXUS_VIEW_DEFAULT = {
  readout: NEXUS_READOUT,
  serff: NEXUS_SERFF_ITEMS,
  sec: NEXUS_SEC_ITEMS,
  news: NEXUS_NEWS_ITEMS,
  linkedinAds: NEXUS_LINKEDIN_ADS_ITEMS,
  metaAds: NEXUS_META_ADS_ITEMS,
  googleAds: [],
  competitors: NEXUS_COMPETITORS,
};

const NexusDataContext = createContext({
  data: NEXUS_VIEW_DEFAULT,
  loading: false,
  error: null,
  adVideoPlaybackEnabled: false,
});

export const NexusDataProvider = ({ value, children }) => (
  <NexusDataContext.Provider value={value}>{children}</NexusDataContext.Provider>
);

export const useNexusData = () => useContext(NexusDataContext);
